package com.shadowings.gero.data.lessons.chapter1

import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.MultiSelectionContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.Characters
import gero.composeapp.generated.resources.*

fun getIntroductionHieroglyphsQuizContent(): List<IQuizContent> {
    val quizList = mutableListOf<IQuizContent>()
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero_calibrati,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero_papera_giraffa,
            correct = false
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero_lettura_bidirezionale,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero_simboli_direzione,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero_quadrati,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero_spazi_vuoti,
            correct = false
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero_trasposti,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero_colore,
            correct = false
        )
    )
    quizList.add(
        MultiSelectionContent(
            text = Res.string.quiz_intro_hiero_multi_1,
            options = listOf(
                Option(Res.string.quiz_intro_hiero_opt_calibrati, true),
                Option(Res.string.quiz_intro_hiero_opt_direzione, true),
                Option(Res.string.quiz_intro_hiero_opt_spazi, false),
                Option(Res.string.quiz_intro_hiero_opt_trasporre, true)
            ).shuffled()
        )
    )
    quizList.add(
        MultiSelectionContent(
            text = Res.string.quiz_intro_hiero_multi_2,
            options = listOf(
                Option(Res.string.quiz_intro_hiero_opt_quadrati, true),
                Option(Res.string.quiz_intro_hiero_opt_ridurre, true),
                Option(Res.string.quiz_intro_hiero_opt_spazi_vuoti, false),
                Option(Res.string.quiz_intro_hiero_opt_trasporre_parola, true)
            ).shuffled()
        )
    )
    return quizList.shuffled()
}

fun getIntroductionHieroglyphsContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_introduzione,
            content = Res.string.exp_content_in_questa_sezione_vedremo_i_principali_fondam,
            face = Faces.Idle,
            image = Res.drawable.swipe_up,
            imageSize = 0.35f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_calibratura,
            content = Res.string.exp_content_i_disegni_geroglifici_sono_calibrati_ovvero_n,
            face = Faces.Idle,
        ),
        ExplanationContent(
            title = Res.string.exp_title_calibratura,
            content = Res.string.exp_content_il_segno_di_una_papera_ha_le_stesse_dimension,
            face = Faces.Surprised,
            image = Res.drawable.same_size,
            imageSize = 0.5f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_orientamento,
            content = Res.string.exp_content_la_lettura_pu_essere_da_destra_a_sinistra_da_,
            face = Faces.Surprised,
        ),
        ExplanationContent(
            title = Res.string.exp_title_orientamento,
            content = Res.string.exp_content_nell_esempio_l_ultimo_simbolo_ra_guarda_verso,
            face = Faces.Happy,
            image = Res.drawable.right_left,
            imageSize = 1f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_orientamento,
            content = Res.string.exp_content_per_capire_il_senso_di_lettura_completa,
            face = Faces.Happy,
            image = Res.drawable.left_right,
            imageSize = 1f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_densit,
            content = Res.string.exp_content_per_non_lasciare_mai_spazi_vuoti_gli_scribi_t,
            face = Faces.Idle,
            image = Res.drawable.squares,
        ),
        ExplanationContent(
            title = Res.string.exp_title_densit,
            content = Res.string.exp_content_nell_intero_quadrato,
            face = Faces.Idle,
            image = Res.drawable.full,
        ),
        ExplanationContent(
            title = Res.string.exp_title_densit,
            content = Res.string.exp_content_in_mezzo_quadrato_verticale,
            face = Faces.Serious,
            image = Res.drawable.left,
        ),
        ExplanationContent(
            title = Res.string.exp_title_densit,
            content = Res.string.exp_content_in_mezzo_quadrato_orizzontale,
            face = Faces.Surprised,
            image = Res.drawable.top,
        ),
        ExplanationContent(
            title = Res.string.exp_title_densit,
            content = Res.string.exp_content_in_un_quarto_di_quadrato,
            face = Faces.Surprised,
            image = Res.drawable.corner,
        ),
        ExplanationContent(
            title = Res.string.exp_title_densit,
            content = Res.string.exp_content_questo_permetteva_di_ottimizzare_lo_spazio_a_,
            face = Faces.Happy,
            image = Res.drawable.book,
        ),
        ExplanationContent(
            title = Res.string.exp_title_densit,
            content = Res.string.exp_content_infatti_se_necessario_i_segni_potevano_essere,
            face = Faces.Surprised,
            image = Res.drawable.space,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nilo,
            content = Res.string.exp_content_miao,
            face = Faces.Idle,
            character = Characters.Nilo
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_fine_della_spiegazione,
            face = Faces.Perfect
        )
    )
}